<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    userComponentProps,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'UploadMeterReadings',
  });

  const componentMetadata = {
    kind: 'page',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    ...userComponentProps,
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const onSumbitCompleted = (...args) => {
    const [event] = args;
    const data = event.data.response.data;

    console.log(data, this);

    if (data == null) {
      resultText.value = messages.value.noRecordsHaveBeenImported;
      return;
    }

    const consumptions = data.consumptions ? data.consumptions.length : 0,
      readings = data.readings ? data.readings.length : 0;

    resultText.value = $fn.value.sprintf(
      messages.value.recordsHaveBeenImported,
      {
        consumptions,
        readings,
      }
    );
  };

  const createConsumptions = ref(false);
  const file = ref(null);
  const formId = ref(null);
  const formName = ref('meterConsumptionImport');
  const resultText = ref(null);
  const templateFileURL = ref(null);
  const messages = ref({
    noRecordsHaveBeenImported: $fn.value.pgettext(
      'UploadMeterReadings',
      'No records have been imported.'
    ),
    recordsHaveBeenImported: $fn.value.pgettext(
      'UploadMeterReadings',
      '%(readings)s readings and %(consumptions)s consumptions have been imported.'
    ),
  });
  const ux = ref([]);
  const b_7315092382398562_noShow = computed(() => false);
  const b_7315092382398562_modalBindings = computed(() => ({
    size: 'md',
  }));
  const b_3086171180629160_validation = computed(() => [
    'ext:xlsx',
    'required',
  ]);

  const $data = computed(() => ({
    createConsumptions: createConsumptions.value,
    file: file.value,
    formId: formId.value,
    formName: formName.value,
    resultText: resultText.value,
    templateFileURL: templateFileURL.value,
    messages: messages.value,
    ux: ux.value,
    b_7315092382398562_noShow: b_7315092382398562_noShow.value,
    b_7315092382398562_modalBindings: b_7315092382398562_modalBindings.value,
    b_3086171180629160_validation: b_3086171180629160_validation.value,
  }));

  const $$load_formId = () => {
    return $fn.value.randomElementId();
  };
  const $$load_templateFileURL = () => {
    return $fn.value.urlFor('get_meter_readings_import_template', {
      format: 'xlsx',
    });
  };

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [
      {
        name: 'createConsumptions',
        cache: { type: 'local', key: 'UploadMeterReadings.createConsumptions' },
      },
      { name: 'file' },
      { name: 'formId' },
      { name: 'formName' },
      { name: 'resultText' },
      { name: 'templateFileURL' },
      { name: 'messages' },
      { name: 'ux' },
      { name: 'b_7315092382398562_noShow', nodeId: '7315092382398562' },
      { name: 'b_7315092382398562_modalBindings', nodeId: '7315092382398562' },
      { name: 'b_3086171180629160_validation', nodeId: '3086171180629160' },
    ],
    loaders: { formId: $$load_formId, templateFileURL: $$load_templateFileURL },
    ux: {},
    dataRefs: {
      createConsumptions,
      file,
      formId,
      formName,
      resultText,
      templateFileURL,
      messages,
      ux,
      b_7315092382398562_noShow,
      b_7315092382398562_modalBindings,
      b_3086171180629160_validation,
    },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  const pageDocument = computed(() => {
    return {
      title: $fn.value.pgettext(
        'UploadMeterReadings|Title',
        'Upload Meter Readings'
      ),
    };
  });
  const documentTitle = computed(() => {
    return pageDocument.value
      ? Array.isArray(pageDocument.value.title)
        ? pageDocument.value.title.filter(Boolean).join(' ')
        : pageDocument.value.title
      : null;
  });

  watch(
    pageDocument,
    (newDoc) => {
      if (newDoc) {
        _pageDocument.value = newDoc;
      }
    },
    { immediate: true }
  );

  const act_7315092382398562_closeModal_z94chb607_getActionArgs = async (
    $event
  ) => {
    return {
      name: props.modalName,
      result: {
        close: true,
        cancel: true,
      },
    };
  };
  const act_648747096704084_script_66qfteow3_value_callable = async (
    $event
  ) => {
    return onSumbitCompleted($event);
  };
  const act_648747096704084_script_66qfteow3_getActionArgs = async ($event) => {
    return {
      value: async () => {
        await act_648747096704084_script_66qfteow3_value_callable($event);
      },
    };
  };
  const act_648747096704084_request_5xiz2kase_getActionArgs = async (
    $event
  ) => {
    return {
      operation: 'create_meter_readings_from_file',
      data: {
        file: file.value,
        create_consumptions: createConsumptions.value,
      },
      contentType: 'multipart/form-data',
    };
  };
  const act_3086171180629160_setData_slowblr2b_getActionArgs = async (
    $event
  ) => {
    return {
      path: 'file',
      value: $event.data,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    };
  };
  const act_4823665167724729_setData_k7r5jnrni_getActionArgs = async (
    $event
  ) => {
    return {
      path: 'createConsumptions',
      value: $event.data,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    };
  };
  const act_2434514588044777_closeModal_ba0brfnif_getActionArgs = async (
    $event
  ) => {
    return {
      name: props.modalName,
      result: {
        close: true,
      },
    };
  };

  const act_7315092382398562_closeModal_z94chb607 =
    new actionTypes.CloseModalAction({
      actionArgs: act_7315092382398562_closeModal_z94chb607_getActionArgs,
    });
  const inst_evh_7315092382398562_close_iqp1h4nbw =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_closeModal_z94chb607,
      event: 'close',
      displayName: 'closeModal',
    });
  const inst_evh_7315092382398562_close = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_close_iqp1h4nbw],
    event: 'close',
  });
  const act_7315092382398562_reloadComponentData_jgxkp50b6 =
    new actionTypes.ReloadComponentDataAction({});
  const inst_evh_7315092382398562_reload_tdtpe167h =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_reloadComponentData_jgxkp50b6,
      event: 'reload',
      displayName: 'reloadComponentData',
    });
  const inst_evh_7315092382398562_reload = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_reload_tdtpe167h],
    event: 'reload',
  });
  const act_8564662037462133_closeComponent_94p4jid2h =
    new actionTypes.CloseComponentAction({});
  const inst_evh_8564662037462133_close_l04xfg7gv =
    new actionTypes.EventHandlerImpl({
      action: act_8564662037462133_closeComponent_94p4jid2h,
      event: 'close',
      displayName: 'closeComponent',
    });
  const inst_evh_8564662037462133_close = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_8564662037462133_close_l04xfg7gv],
    event: 'close',
  });
  const act_648747096704084_script_66qfteow3 = new actionTypes.ScriptAction({
    actionArgs: act_648747096704084_script_66qfteow3_getActionArgs,
  });
  const inst_evh_648747096704084_success_76iumnkw1 =
    new actionTypes.EventHandlerImpl({
      action: act_648747096704084_script_66qfteow3,
      event: 'success',
      displayName: 'script',
    });
  const act_648747096704084_request_5xiz2kase = new actionTypes.RequestAction({
    actionArgs: act_648747096704084_request_5xiz2kase_getActionArgs,
    displayName: 'submit',
    events: [inst_evh_648747096704084_success_76iumnkw1],
  });
  const inst_evh_648747096704084_submit_nutpnzlg6 =
    new actionTypes.EventHandlerImpl({
      action: act_648747096704084_request_5xiz2kase,
      event: 'submit',
      displayName: 'submit',
    });
  const inst_evh_648747096704084_submit = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_648747096704084_submit_nutpnzlg6],
    event: 'submit',
  });
  const act_3086171180629160_setData_slowblr2b = new actionTypes.SetDataAction({
    actionArgs: act_3086171180629160_setData_slowblr2b_getActionArgs,
  });
  const inst_evh_3086171180629160_updateModelValue_e55rvudqq =
    new actionTypes.EventHandlerImpl({
      action: act_3086171180629160_setData_slowblr2b,
      event: 'update:modelValue',
      displayName: 'setData',
    });
  const inst_evh_3086171180629160_updateModelValue =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_3086171180629160_updateModelValue_e55rvudqq],
      event: 'update:modelValue',
    });
  const act_4823665167724729_setData_k7r5jnrni = new actionTypes.SetDataAction({
    actionArgs: act_4823665167724729_setData_k7r5jnrni_getActionArgs,
  });
  const inst_evh_4823665167724729_updateModelValue_kg887qryh =
    new actionTypes.EventHandlerImpl({
      action: act_4823665167724729_setData_k7r5jnrni,
      event: 'update:modelValue',
      displayName: 'setData',
    });
  const inst_evh_4823665167724729_updateModelValue =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_4823665167724729_updateModelValue_kg887qryh],
      event: 'update:modelValue',
    });
  const act_2434514588044777_closeModal_ba0brfnif =
    new actionTypes.CloseModalAction({
      actionArgs: act_2434514588044777_closeModal_ba0brfnif_getActionArgs,
    });
  const inst_evh_2434514588044777_clickPreventStop_otn3zxaj8 =
    new actionTypes.EventHandlerImpl({
      action: act_2434514588044777_closeModal_ba0brfnif,
      event: 'click.prevent.stop',
      displayName: 'closeModal',
    });
  const inst_evh_2434514588044777_clickPreventStop =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_2434514588044777_clickPreventStop_otn3zxaj8],
      event: 'click.prevent.stop',
    });

  const actions = {
    inst_evh_7315092382398562_close_iqp1h4nbw,
    inst_evh_7315092382398562_close,
    inst_evh_7315092382398562_reload_tdtpe167h,
    inst_evh_7315092382398562_reload,
    inst_evh_8564662037462133_close_l04xfg7gv,
    inst_evh_8564662037462133_close,
    inst_evh_648747096704084_success_76iumnkw1,
    inst_evh_648747096704084_submit_nutpnzlg6,
    submit: inst_evh_648747096704084_submit_nutpnzlg6,
    inst_evh_648747096704084_submit,
    inst_evh_3086171180629160_updateModelValue_e55rvudqq,
    inst_evh_3086171180629160_updateModelValue,
    inst_evh_4823665167724729_updateModelValue_kg887qryh,
    inst_evh_4823665167724729_updateModelValue,
    inst_evh_2434514588044777_clickPreventStop_otn3zxaj8,
    inst_evh_2434514588044777_clickPreventStop,
  };

  const evh_7315092382398562_close_iqp1h4nbw = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_close_iqp1h4nbw.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_close = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_close.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload_tdtpe167h = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload_tdtpe167h.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8564662037462133_close_l04xfg7gv = async (event, scope) => {
    return await actions.inst_evh_8564662037462133_close_l04xfg7gv.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8564662037462133_close = async (event, scope) => {
    return await actions.inst_evh_8564662037462133_close.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_648747096704084_success_76iumnkw1 = async (event, scope) => {
    return await actions.inst_evh_648747096704084_success_76iumnkw1.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_648747096704084_submit_nutpnzlg6 = async (event, scope) => {
    return await actions.inst_evh_648747096704084_submit_nutpnzlg6.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_648747096704084_submit = async (event, scope) => {
    return await actions.inst_evh_648747096704084_submit.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3086171180629160_updateModelValue_e55rvudqq = async (
    event,
    scope
  ) => {
    return await actions.inst_evh_3086171180629160_updateModelValue_e55rvudqq.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3086171180629160_updateModelValue = async (event, scope) => {
    return await actions.inst_evh_3086171180629160_updateModelValue.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_4823665167724729_updateModelValue_kg887qryh = async (
    event,
    scope
  ) => {
    return await actions.inst_evh_4823665167724729_updateModelValue_kg887qryh.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_4823665167724729_updateModelValue = async (event, scope) => {
    return await actions.inst_evh_4823665167724729_updateModelValue.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_2434514588044777_clickPreventStop_otn3zxaj8 = async (
    event,
    scope
  ) => {
    return await actions.inst_evh_2434514588044777_clickPreventStop_otn3zxaj8.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_2434514588044777_clickPreventStop = async (event, scope) => {
    return await actions.inst_evh_2434514588044777_clickPreventStop.executeFromDOM(
      $component,
      event,
      scope
    );
  };

  defineExpose({
    documentTitle,
    pageDocument: _pageDocument,
    routeTab,
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <ItpPage
    :header="documentTitle"
    :loaded="loaded"
    :noShow="b_7315092382398562_noShow"
    :loading="showLoadingIndicator"
    :reloading="reloading"
    :error="error"
    :modal="modal"
    :modalBindings="b_7315092382398562_modalBindings"
    itp-cname="UploadMeterReadings"
    @close="evh_7315092382398562_close($event, {})"
    @reload="evh_7315092382398562_reload($event, {})"
  >
    <template #header>
      <UcHeader
        :card="!modal"
        :modal="modal"
        :title="documentTitle"
        v-if="loaded"
        @close="evh_8564662037462133_close($event, {})"
      >
      </UcHeader>
    </template>
    <UcBody :card="!modal" :modal="modal" v-if="loaded">
      <ItpAlert variant="info" show>
        <ItpIcon fa="info-circle"> </ItpIcon>
        <ItpText wrap>
          {{
            pgettext(
              'UploadMeterReadings',
              'Upload meter readings from a template file and optionally generate consumption data.'
            )
          }}
        </ItpText>
      </ItpAlert>
      <hr />
      <div class="container">
        <ItpForm
          :name="formName"
          :id="formId"
          v-if="loaded"
          @submit="evh_648747096704084_submit($event, {})"
        >
          <ItpFormGroup
            name="file"
            :label="pgettext('UploadMeterReadings', 'Events file')"
            labelFor="file"
            required
          >
            <ItpFormFile
              :modelValue="file"
              name="file"
              accept=".xlsx"
              required
              :validation="b_3086171180629160_validation"
              @update:modelValue="
                evh_3086171180629160_updateModelValue($event, {})
              "
            >
            </ItpFormFile>
            <template #description>
              <div class="pt-2">
                <span>
                  {{
                    pgettext(
                      'UploadMeterReadings',
                      'Only XLSX files are allowed.'
                    )
                  }}
                </span>
                <ItpLink
                  :text="pgettext('UploadMeterReadings', 'Download template')"
                  :href="templateFileURL"
                  use-auth
                  force-download
                  downloadFileName="meter-readings-template.xlsx"
                >
                </ItpLink>
              </div>
            </template>
          </ItpFormGroup>
          <div name="createConsumptions" class="form-check px-0">
            <ItpFormCheckbox
              name="createConsumptions"
              :modelValue="createConsumptions"
              @update:modelValue="
                evh_4823665167724729_updateModelValue($event, {})
              "
            >
              {{ pgettext('UploadMeterReadings', 'Create consumptions') }}
            </ItpFormCheckbox>
          </div>
        </ItpForm>
        <ItpAlert :show="resultText && !actions.submit.isRunning" class="mt-3">
          <ItpIcon fa="info-circle"> </ItpIcon>
          <span>
            {{ resultText }}
          </span>
        </ItpAlert>
      </div>
    </UcBody>
    <template #footer>
      <UcFooter :card="!modal" :modal="modal" v-if="loaded">
        <ItpButton
          :form="formId"
          :text="pgettext('UploadMeterReadings', 'Upload')"
          type="submit"
          variant="primary"
          icon="fa-file-import"
          :spinning="actions.submit.isRunning"
          :disabled="!forms[formName] || !forms[formName].submittable"
        >
        </ItpButton>
        <ItpButton
          :text="gettext('Close')"
          variant="default"
          :disabled="actions.submit.isRunning"
          @click.prevent.stop="
            evh_2434514588044777_clickPreventStop($event, {})
          "
        >
        </ItpButton>
      </UcFooter>
    </template>
  </ItpPage>
</template>
